import { Document } from '~/models/document/Document'
import { Category } from '~/models/document/Category'

export class DocumentsState {
  public documents: { [key: string]: Document[] } = {}
  public categories: { [key: string]: Category[] } = {}
}

export default (): DocumentsState => new DocumentsState()
